export default __webpack_public_path__ + "static/media/logo-BG.db6144e5.svg";